import React from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import './CookiePolicyPage.scss';

export function CookiePolicyPage() {
    const { resetConsent } = useCookieConsent();
    return (
        <div className='cookie-policy'>
            <h1 className='cookie-policy__title'>Политика в отношении обработки cookie-файлов</h1>
            <p className='cookie-policy__updated'>Дата последнего обновления: март 2025 г.</p>

            <section className='cookie-policy__section'>
                <h2>Что такое cookie</h2>
                <p>
                    Cookie (куки) — это небольшой текстовый файл, который сохраняется в браузере при посещении интернет-сайта
                    ООО «Вояж Глобал» (далее — сайт). Файл фиксирует действия пользователя и позволяет не вводить повторно
                    одни и те же данные при следующем визите (например, контактный номер телефона или выбранные параметры поиска).
                </p>
            </section>

            <section className='cookie-policy__section'>
                <h2>Цели использования cookie</h2>
                <p>
                    Обработка cookie направлена на повышение удобства использования сайта и улучшение качества его работы.
                    Мы не передаём cookie третьим лицам и не применяем их для идентификации субъектов персональных данных.
                </p>
            </section>

            <section className='cookie-policy__section'>
                <h2>Типы cookie на сайте</h2>
                
                <h3>Функциональные cookie</h3>
                <p>
                    Обеспечивают персонализированный опыт использования сайта и устанавливаются в ответ на действия пользователя.
                </p>
                <div className='cookie-policy__table-wrapper'>
                    <table className='cookie-policy__table'>
                        <thead>
                            <tr>
                                <th>Название cookie</th>
                                <th>Поставщик</th>
                                <th>Срок хранения</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>cookie_consent</td>
                                <td>ООО «Вояж Глобал»</td>
                                <td>395 дней</td>
                            </tr>
                            <tr>
                                <td>session_id</td>
                                <td>ООО «Вояж Глобал»</td>
                                <td>До завершения сеанса браузера</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3>Статистические cookie</h3>
                <p>
                    Сохраняют историю посещений страниц для анализа популярности разделов сайта и улучшения его функционирования.
                </p>
                <div className='cookie-policy__table-wrapper'>
                    <table className='cookie-policy__table'>
                        <thead>
                            <tr>
                                <th>Название cookie</th>
                                <th>Поставщик</th>
                                <th>Срок хранения</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>_ym_uid</td>
                                <td>yandex.ru</td>
                                <td>12 месяцев</td>
                            </tr>
                            <tr>
                                <td>_ga</td>
                                <td>google.com</td>
                                <td>24 месяца</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className='cookie-policy__section'>
                <h2>Управление cookie</h2>
                <p>
                    Помимо настроек на сайте, пользователи могут принять или отклонить сбор всех или части cookie в настройках
                    своего браузера. Некоторые браузеры поддерживают режим «инкогнито» или «гость», что ограничивает объём
                    сохраняемой информации и автоматически удаляет сессионные cookie. Пользователь также может удалить
                    ранее сохранённые cookie через историю браузера.
                </p>
                <p>
                    Следует учитывать, что корректная работа сайта возможна только при использовании функциональных cookie.
                    При их отключении может потребоваться повторный выбор предпочтений. Отключение статистических cookie
                    не позволяет анализировать предпочтения пользователей и совершенствовать работу сайта.
                </p>
            </section>

            <section className='cookie-policy__section'>
                <h2>Изменение настроек</h2>
                <p>
                    Вы можете в любой момент изменить своё решение об использовании cookie. Нажмите кнопку ниже,
                    чтобы снова увидеть уведомление и сделать новый выбор.
                </p>
                <button type='button' className='cookie-policy__reset-btn' onClick={resetConsent}>
                    Изменить настройки cookie
                </button>
            </section>

            <section className='cookie-policy__section'>
                <h2>Ссылки на настройки браузеров</h2>
                <p>
                    Подробнее об управлении cookie можно узнать на страницах поддержки основных браузеров:
                </p>
                <ul className='cookie-policy__links'>
                    <li>
                        <a href='https://support.google.com/chrome/answer/95647?hl=ru' target='_blank' rel='noopener noreferrer'>
                            Google Chrome
                        </a>
                    </li>
                    <li>
                        <a href='https://support.microsoft.com/ru-ru/microsoft-edge/удаление-файлов-cookie-в-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09' target='_blank' rel='noopener noreferrer'>
                            Microsoft Edge
                        </a>
                    </li>
                    <li>
                        <a href='https://support.apple.com/ru-ru/guide/safari/sfri11471/mac' target='_blank' rel='noopener noreferrer'>
                            Safari
                        </a>
                    </li>
                    <li>
                        <a href='https://support.mozilla.org/ru/kb/udalenie-kukov-dlya-udaleniya-informacii-kotoruyu' target='_blank' rel='noopener noreferrer'>
                            Mozilla Firefox
                        </a>
                    </li>
                    <li>
                        <a href='https://help.opera.com/ru/latest/web-preferences/#Управление-файлами-cookie' target='_blank' rel='noopener noreferrer'>
                            Opera
                        </a>
                    </li>
                </ul>
            </section>
        </div>
    );
}
